<template>
  <div>
    <!-- TOP PANEL -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100 mx-auto text-center">
        <h2 class="title">Bem vindo à iSET</h2>
        <h5 class="description mobile-hidden">
          A plataforma de e-commerce mais livre, flexível, eficiente e estável para sua loja virtual!
        </h5>
      <!-- PAGAMENTO COM CARTÃO DE CRÉDITO -->
      <md-card class="info-card payment" v-if="invoice.id > 0 && invoice.status == 'Unpaid' && order.paymentMethod == 'creditcard'">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>receipt</md-icon>
          </div>
          <h4 class="title">Obrigado pelo seu pedido!</h4>
        </md-card-header>
        <md-card-content>
          <ul>
            <li>Fatura #{{invoice.id}}</li>
            <li>Primeiro pagamento: R${{$functions.currencyFormat(order.total, 2)}}</li>              
          </ul>            
          <a :href="invoiceUrl" @click="invoiceClick" target="_blank"><md-button class="md-success">Efetuar Pagamento</md-button></a>
        </md-card-content>
      </md-card>

      <!-- PAGAMENTO PIX E BOLETO -->
      <md-card class="info-card mobile-hidden" v-if="invoice.id > 0 && invoice.status == 'Unpaid' && order.paymentMethod != 'creditcard'">
        <md-card-content class="payment-pix">
          <iframe
            v-show="true"
            :src="paymentUrl"
            @load="pixIsLoaded"
            width="100%"
            height="100%"
          />
        </md-card-content>
        <md-card-actions>
          <a :href="invoiceUrl" @click="invoiceClick" target="_blank"><md-button class="md-success slim-button inverted">Pagar com Cartão de Crédito ou Boleto</md-button></a>
        </md-card-actions>
      </md-card>

      <md-card class="info-card desktop-hidden payment" v-if="invoice.id > 0 && invoice.status == 'Unpaid' && order.paymentMethod != 'creditcard'">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>receipt</md-icon>
          </div>
          <h4 class="title">Obrigado pelo seu pedido!</h4>
        </md-card-header>
        <md-card-content>
          <ul>
            <li>Fatura #{{invoice.id}}</li>
            <li>Primeiro pagamento: R${{$functions.currencyFormat(order.total, 2)}}</li>              
          </ul>            
          <a :href="invoiceUrl" @click="invoiceClick" target="_blank"><md-button class="md-success">Efetuar Pagamento</md-button></a>
        </md-card-content>
      </md-card>

      </div>      
    </div>    
    <!-- END TOP PANEL -->

    <div class="md-layout">
      <!-- LEFT PANEL -->
      <div class="md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-50 md-size-50">
        
        <md-card class="info-card">
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>support</md-icon>
            </div>
            <h4 class="title">Primeiros Passos</h4>
          </md-card-header>
          <md-card-content>            
            <p><b>Assista ao vídeo abaixo</b> onde nosso CEO, Paulo Pina, irá lhe ajudar a entender de forma fácil e eficiente, tudo o que precisa para deixar sua loja virtual pronta para vender. Vamos lá?</p>
            <iframe class="wellcome-video" width="100%" height="480" src="https://www.youtube.com/embed/yNCCjqV8WhY?autoplay=1" title="Seja bem vindo à iSET!" frameborder="0" scrolling="no" allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            <h5>Não perca tempo!</h5>
            <p>Inicie agora mesmo seu  <b>TREINAMENTO GRATUITO</b>. Assista aos vídeos quando quiser e marque reuniões com nossos especialistas.</p>
            <a :href="supportPanel.trainingLink" @click="trainingClick" target="_blank"><img src="/img/banner-onboarding.png"/></a>            
          </md-card-content>
          <md-card-actions>
            <a :href="supportPanel.helpLink" @click="helpClick" target="_blank"><md-button class="md-info slim-button inverted mobile-hidden">Acessar os Tutoriais</md-button></a>
            <a :href="supportPanel.trainingLink" @click="trainingClick" target="_blank"><md-button class="md-info slim-button">Inicie seu Treinamento</md-button></a>
          </md-card-actions>
        </md-card>

      </div>
      <!-- END LEFT PANEL-->


      <!-- RIGHT PANEL -->
      <div class="md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-50 md-size-50">      
        <md-card class="info-card">
          <md-card-header class="md-card-header-icon md-card-header-warning">
            <div class="card-icon">
              <md-icon>store</md-icon>
            </div>
            <h4 class="title">Loja Virtual</h4>
          </md-card-header>
          <md-card-content>
            <ul>
              <p>Enquanto você não adiciona um domínio em sua loja, você poderá acessá-la pelo endereço temporário.</p>
              <li><b>Link temporário: </b>
                <a :href="ecommercePanel.tempURL" @click="catalogClick" target="_blank">{{ecommercePanel.tempURL}}</a></li>
              <li><b>Login: </b>
                <!--span v-if="!userCreated">iset</span>
                <span v-if="userCreated">{{ecommercePanel.login}}</span-->
                <span>{{ecommercePanel.login}}</span>
              </li>
              <li><b>Senha: </b>                 
                <a href="#" @click="togglePwd" v-if="!showPwd">******** (mostrar senha)</a>
                <a href="#" @click="togglePwd" v-if="showPwd">{{ecommercePanel.password}} (esconder senha)</a>
              </li>
              <p v-if="!userCreated"><small>Sua loja não pode ser ativada automaticamente. Estamos trabalhando na ativação manual da loja, mas você pode entrar em contato com nosso atendimento para agilizar o processo.</small></p>
              <p><small>Para acessar o painel administrativo, basta adicionar /admin ao final do link</small></p>
            </ul>            
          </md-card-content>
          <md-card-actions>            
            <a :href="ecommercePanel.tempCatalogLink" @click="catalogClick" target="_blank"><md-button class="md-warning slim-button inverted">Catálogo</md-button></a>            
            <a v-if="userCreated" :href="ecommercePanel.tempAdminLink" @click="adminClick" target="_blank"><md-button class="md-warning slim-button">Painel Admin<span class="mobile-hidden">istrativo</span></md-button></a>
            <a v-if="!userCreated" @click="createUserPost" target="_blank"><md-button class="md-warning slim-button">Painel Admin<span class="mobile-hidden">istrativo</span></md-button></a>
          </md-card-actions>
        </md-card>

        <md-card class="info-card">
          <md-card-header class="md-card-header-icon md-card-header-default">
            <div class="card-icon">
              <md-icon>cloud</md-icon>
            </div>
            <h4 class="title">Seu Domínio<span v-if="order.hosting"> e E-mails</span></h4>
          </md-card-header>
          <md-card-content>
            <p v-if="order.hosting">Agora você conta com a hospedagem da iSET para seu domínio e seus e-mails profissionais @{{ domain.base + "." + domain.extension }}.</p>            
            <ul>
              <li><a :href="supportPanel.helpDomain" @click="helpClick" target="_blank">Veja como adicionar um domínio em sua loja virtual</a></li>
              <li v-if="order.hosting"><a :href="supportPanel.helpDNS" @click="helpClick" target="_blank">Veja como apontar seu domínio (DNS) para a iSET</a></li>
              <li v-if="!order.hosting && !nextSteps.domainRegister"><a :href="supportPanel.helpCNAME" @click="helpClick" target="_blank">Veja como apontar seu domínio (CNAME) para a iSET</a></li>
              <li v-if="order.hosting"><a :href="supportPanel.helpEmail" @click="helpClick" target="_blank">Veja como criar e-mails @{{ domain.base + "." + domain.extension }}</a></li>
            </ul>
            <p v-if="nextSteps.domainRegister">
              <small>
                <b>Você escolheu um domínio que ainda não está registrado.</b><br/>
                É importante que você faça o registro o quanto antes para garantir esse endereço.
              </small>
              <a :href="hostingPanel.domainRegisterLink" @click="hostingClick" target="_blank">
                <img class="mobile-hidden" src="/img/domain-register-slim.jpeg"/>
                <img class="desktop-hidden" src="/img/domain-register-big.jpeg"/>
              </a>              
            </p>            
          </md-card-content>
          <md-card-actions>
            <a v-if="order.hosting && !nextSteps.domainRegister" :href="supportPanel.helpDNS" @click="trainingClick" target="_blank"><md-button class="md-default slim-button inverted">Aponte seu Domínio para a iSET</md-button></a>
            <a v-if="!order.hosting && !nextSteps.domainRegister" :href="supportPanel.helpCNAME" @click="trainingClick" target="_blank"><md-button class="md-default slim-button inverted">Aponte seu Domínio para a iSET</md-button></a>
            <a v-if="nextSteps.domainRegister" :href="hostingPanel.domainRegisterLink" @click="hostingClick" target="_blank"><md-button class="md-danger slim-button">Registre seu Domínio</md-button></a>
          </md-card-actions>
        </md-card>

      </div>
      <!-- END RIGHT PANEL -->
    </div>

    <!-- BOTTOM PANEL -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100 mx-auto">
        <md-card class="info-card">
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>support</md-icon>
            </div>
            <h4 class="title">Obtenha Ajuda</h4>
          </md-card-header>
          <md-card-content>

            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100 mx-auto">
                <ul>
                  <li><a :href="supportPanel.helpLink" @click="helpClick" target="_blank">Tutoriais em texto e vídeo</a></li>
                  <li><a :href="supportPanel.youtubeLink" @click="socialClick" target="_blank">Youtube da iSET</a></li>
                  <li><a :href="supportPanel.blogLink" @click="socialClick" target="_blank">Blog da iSET</a></li>
                </ul>
                <ul>
                  <li><a :href="customerPanel.clientareaLink" @click="clientareaClick" target="_blank">Central do Cliente</a></li>                  
                  <li><a :href="customerPanel.ticketsLink" @click="clientareaClick" target="_blank">Suporte via ticket</a></li>
                </ul>
                <ul>
                  <li><a href="https://api.whatsapp.com/send?phone=5531983480703&text=Ol%C3%A1!+Preciso+falar+com+a+equipe+comercial&utm_source=Wpp&utm_medium=Ajuda&utm_campaign=comercial_wpp_ajuda_novo" @click="helpClick" target="_blank">Fale com um consultor comercial</a></li>
                </ul>
                <p><small>Para acessar a <a :href="customerPanel.clientareaLink" @click="clientareaClick" target="_blank">central do cliente</a>, utilize o mesmo e-mail e senha que você utilizou em seu cadastro aqui.</small></p>
              </div>
              <div class="md-layout-item md-size-35 md-small-size-100 mx-auto text-center">
                <a href="https://bit.ly/3NJtphD" @click="socialClick">
                  Nossa Comunidade
                  <img src="/img/qrcode-wpp-comunidade.jpeg" style="max-height: 250px; width: auto;"/>
                </a>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-100 mx-auto text-center">
                <a href="https://api.whatsapp.com/send?phone=5531983287098&text=Ol%C3%A1,%20tudo%20bem?%20Tenho%20uma%20duvida,%20voc%C3%AA%20poderia%20me%20ajudar?%20" @click="helpClick">
                  Suporte via WhatsApp
                  <img src="/img/qrcode-wpp-suporte.svg" style="max-height: 230px; width: auto; margin-top: 10px;"/>
                </a>
              </div>
            </div>
            <p><small><b>Confira seu e-mail {{ client.email }}:</b><br/>Enviamos um e-mail com estas informações de ativação de sua loja, caso não seja você que irá configurar a loja virtual, por favor encaminhe para a pessoa responsável. Aproveite e adicione a iSET em sua lista de contatos para receber todas as nossas comunicações.</small></p>
          </md-card-content>
        </md-card>          
      </div>      
    </div>    
    <!-- END BOTTOM PANEL -->

  </div>
</template>

<script>
import Swal from "sweetalert2";
//import {} from '@/components'

export default {
  //components: {},

  data() {
    return {      
      session: this.$store.state.session,
      client: this.$store.state.client,
      business: this.$store.state.business,
      address: this.$store.state.address,
      domain: this.$store.state.domain,
      plan: this.$store.state.plan,
      order: this.$store.state.order,      
      hosting: this.$store.state.hosting,      
      ecommerce: this.$store.state.ecommerce,
      invoice: this.$store.state.invoice,

      paymentUrl: "https://ica.iset.com.br/modules/gateways/paghiper_pix.php?invoiceid="+this.$store.state.invoice.id+"&uuid="+this.$store.state.client.id+"&mail="+this.$store.state.client.email+"&pix=true",
      invoiceUrl: "https://ica.iset.com.br/viewinvoice.php?id="+this.$store.state.invoice.id+"&access_token="+this.$store.state.client.access_token,
      // invoiceUrl: this.$store.state.invoice.url,

      showPwd: false,
      userCreated: this.$store.state.ecommerce.userCreated,
      
      nextSteps: {
        domainRegister:       this.$store.state.domain.status == "available",
        ecommerceFail:        this.$store.state.ecommerce.status != "Active",
        hostingFail:          this.$store.state.hosting.id > 0 && this.$store.state.order.hosting == true && this.$store.state.hosting.status != "Active",
        ecommerceInfo:        true,
        inboxInfo:            true,
        trainingInfo:         true,
        emailInfo:            this.$store.state.hosting.id > 0,
        subdomainInfo:        this.$store.state.domain.subdomain != "" && this.$store.state.domain.subdomain != "www",
        externalHostingInfo:  !this.$store.state.hosting.id > 0,
        domainInfo:           this.$store.state.hosting.id > 0 && this.$store.state.order.hosting == true && this.$store.state.domain.status != "available",
      },      

      ecommercePanel: {
        finalURL: this.$store.state.domain.protocol + "://" + (this.$store.state.domain.subdomain ? this.$store.state.domain.subdomain + "." : "www.") + this.$store.state.domain.base + "." + this.$store.state.domain.extension,
        tempURL: this.$store.state.tempProtocol + "://" + this.$store.state.domain.base + "." + this.$store.state.tempDomain,
        login: this.$store.state.client.email,
        password: this.$store.state.password,
        tempCatalogLink: this.$store.state.tempProtocol + "://" + this.$store.state.domain.base + "." + this.$store.state.tempDomain,
        tempAdminLink: this.$store.state.tempProtocol + "://" + this.$store.state.domain.base + "." + this.$store.state.tempDomain + "/admin" + (this.$store.state.ecommerce.userToken ? '/?token=' + this.$store.state.ecommerce.userToken : ''),
      },

      supportPanel: {        
        helpLink: "https://ajuda.iset.com.br",
        helpDomain: "https://help.iset.com.br/dominios-conectar/",
        helpDNS: "https://help.iset.com.br/dns-no-registro-br/",
        helpCNAME: "https://help.iset.com.br/vinculandoo-dominio-registrobr/",
        helpEmail: "https://help.iset.com.br/criar-conta-de-e-mail/",
        trainingLink: "https://ajuda.iset.com.br/pt-br/Introducao-ao-onboarding",
        youtubeLink: "https://www.youtube.com/isetbrasil",
        blogLink: "https://www.iset.com.br/blog",
      },

      hostingPanel: {
        cpanelLink: this.$store.state.domain.protocol + "://cpanel." + this.$store.state.domain.base + "." + this.$store.state.domain.extension,
        cpanelDirectLink: "https://ica.iset.com.br/clientarea.php?action=productdetails&id="+ this.$store.state.hosting.id +"&dosinglesignon=1",
        emailsLink: "https://ica.iset.com.br/?m=iset_emails",
        domainRegisterLink: "https://meunegocio.uol.com.br/lp/dominios/iset",
      },

      customerPanel: {
        clientareaLink: "https://ica.iset.com.br/",
        ticketsLink: "https://ica.iset.com.br/submitticket.php",
      },

    };
  },
  
  
  mounted: function () {
    this.$nextTick(function () {
      if (this.$store.state.session.id && this.$store.state.client.email && this.$store.state.order.id){
        const params = {'id'    : this.$store.state.session.id,
                        'email' : this.$store.state.client.email,                      
                        'counter_finish' : 1 };
        this.$functions.addTrack(params);
      }

      // this.$gtm.trackEvent({
      //   event: 'Concluído',
      //   category: "identification",
      //   action: "view",
      //   noninteraction: false,
      // });


      if (this.invoice.id > 0 && this.order.paymentMethod == 'creditcard')
        this.$functions.showInfo('O pagamento de sua primeira fatura está sendo processado, enquanto isso sua loja já foi ativada. Por favor siga as instruções desta página para seus próximos passos =).', 'warning');
      else if (this.invoice.id > 0 && this.invoice.status == 'Unpaid' && this.order.paymentMethod != 'creditcard')
        this.$functions.showInfo('Por favor, conclua o pagamento de sua primeira fatura e siga as instruções nessa página para seus próximos passos =).', 'warning');

    });
  },

  methods: {
    catalogClick(){     this.updateClick('catalog'); },
    adminClick(){       this.updateClick('admin'); },
    helpClick(){        this.updateClick('help'); },
    trainingClick(){    this.updateClick('training'); },
    hostingClick(){     this.updateClick('hosting'); },
    socialClick(){      this.updateClick('social'); },
    clientareaClick(){  this.updateClick('ica'); },
    invoiceClick() {    this.updateClick('invoice'); },
    
    pixIsLoaded(){
      console.log('PIX Loaded');
    },

    togglePwd(){
      this.showPwd = !this.showPwd;
    },

    updateClick(option){
      this.$debug("Finished => updateClick: " + option);
      const field = "pressed_" + option;

      const params = {'id'    : this.$store.state.session.id,
                      'email' : this.$store.state.client.email,                      
                      [field] : 1 };
      this.$functions.addTrack(params);
    },

    async createUserPost() {
      this.$debug('Finished => createUserPost');
      // Construindo o objeto de dados a ser enviado no corpo da requisição
      const data = {
        serviceid: this.ecommerce.id,
        domain: this.domain.base + "." + this.$store.state.tempDomain,
        name: this.client.firstName,
        email: this.client.email,
        cellphone: this.client.phone,
        password: this.$store.state.password
      };

      try {
        // Fazendo a requisição POST
        const response = await fetch('https://api.ai.iset.io/v1/iset/createUser', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': this.$store.state.token,
          },
          body: JSON.stringify(data)
        });

        // Verificando se a resposta foi bem sucedida
        if (response.ok) {
          const result = await response.json();

          // Verificando se a resposta contém uma URL de redirecionamento
          if (result.redirectUrl) {
            this.$debug('Redirecting to:', result.redirectUrl);
            window.open(result.redirectUrl, '_blank'); // Abre a URL em uma nova aba
          } else {
            this.$debug('No redirect URL found in response:', result);
          }
        } else {
          this.$debug('Failed to create user:', response.statusText);
        }
      } catch (error) {
        this.$debug('Error occurred during user creation:', error);
      }

      this.updateClick('admin');
    },

    async createUser(){
      this.$debug('Finished => createUser');
      this.updateClick('admin');

      // Aqui, você pode construir a URL com base nos parâmetros desejados
      const url = `https://api.ai.iset.io/v1/iset/createUser?serviceid=${encodeURIComponent(this.ecommerce.id)}&domain=${encodeURIComponent(this.domain.base + "." + this.$store.state.tempDomain)}&name=${encodeURIComponent(this.client.firstName)}&email=${encodeURIComponent(this.client.email)}&cellphone=${encodeURIComponent(this.client.phone)}&password=${encodeURIComponent(this.$store.state.password)}`;

      // Agora, ao invés de fazer a requisição GET, abrimos a URL de criação de usuário que irá redirecionar para o painel
      window.open(url, '_blank');
      //window.location.href = url;

      // Já que estamos redirecionando a página, não há retorno da função a ser considerado
    },

    // async createUser2(){
    //   this.$debug('Finished => createUser');
    //   this.updateClick('admin');

    //   const params = {'serviceid':  this.ecommerce.id,
    //                   'domain':     this.domain.base + "." + this.$store.state.tempDomain,
    //                   'name':       this.client.firstName,
    //                   'email':      this.client.email, 
    //                   'cellphone':  this.client.phone, 
    //                   'password':   this.$store.state.password };

    //   this.$debug('CREATE USER');
    //   let result = await this.$functions.get('createUser', params, 'order.php').then((response) => {
    //     if (response.result == 'success'){
    //       this.$store.commit('ecommerce', ['userCreated', true]);
    //       this.$store.commit('ecommerce', ['userToken', response.token]);
    //     } else {
    //       this.$debug(response.message);
    //       return response.message;
    //     }
    //   });

    //   return result;
    // },


  },

}
</script>

<style lang="scss">
@import "../assets/scss/activation.scss";

h2{
  margin-top: 0px;
}

.md-card-actions{
  padding-top: 20px !important;
}

.bg-top{
  display: none;
}

.payment-pix{
  height: 480px;
  overflow: hidden;
}
.payment-pix iframe{
  height: 480px;
  border: none;
}

.wellcome-video {
  height: 340px !important;
}

.md-card-content p{
  font-size: 1rem;
}

.info-card.payment li{
  list-style-type: none;
}

.next-steps{
  margin-top: 0;
}

.next-steps .timeline.timeline-simple:before{
  background-color: $gray !important;
  opacity: 0.2;
}

.next-steps .timeline .timeline-panel{
  padding: 10px !important;
}

.next-steps .timeline .timeline-footer p{
  font-size: 12px;
  text-transform: none;
  margin: 0px;
}

.next-steps .timeline .dropdown-toggle.md-button {  
  line-height: 1;
  font-size: 12px;
  font-weight: 400;
}
.next-steps .timeline .dropdown-toggle.md-button .md-ripple{
  padding: 7px 20px !important;
}

.onboarding-container{
  width: 598px !important;
  height: 322px !important;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  overflow: hidden !important;
}

.onboarding-container ._vs_ictr_player{
  width: 100% !important;
  height: 100% !important;
}

.onboarding-container ._vs_ictr_player-wrapper{
  width: 100% !important;
  height: 100% !important;
}

@media only screen and (max-width: 1200px) {
  .onboarding-container{
    width: 490px !important;
    height: 270px !important;
  }
}

@media only screen and (max-width: 992px) {
  .onboarding-container{
    width: 345px !important;
    height: 186px !important;
  }
}

@media only screen and (max-width: 960px) {
  .onboarding-container{
    width: 640px !important;
    height: 345px !important;
  }
}

@media only screen and (max-width: 767px) {
  .onboarding-container{
    width: 440px !important;
    height: 227px !important;
  }
}

@media only screen and (max-width: 480px) {
  .onboarding-container{
    width: 320px !important;
    height: 180px !important;
  }
}
</style>
